import { Checkbox, DatePicker, Form, FormInstance, Input, InputNumber, Select, Space } from "antd";
import { useCallback } from "react";
import FormWrapper from "../../../../../components/UI/FormWrapper/FormWrapper";
import { DynamicClaimsApiFields } from "./ClaimForm";
import { errorNotification } from "../../../../../components/UI/Toast/Toast";

interface Props {
  onNext?: VoidFunction;
  onPrev?: VoidFunction;
  form: FormInstance;
  readonly?: boolean;
  dynamicFields: DynamicClaimsApiFields[];
}

const renderDynamicFormField = (fieldData: DynamicClaimsApiFields, readonly?: boolean) => {
  if (!fieldData) return null;
  switch (fieldData?.field_type) {
    case 'Text':
      return <Input placeholder={`Enter ${fieldData?.label || fieldData?.field_name}`} disabled={readonly} />;
    case 'Number':
      return <InputNumber style={{ width: '100%' }} placeholder={`Enter ${fieldData?.label || fieldData?.field_name}`} disabled={readonly} />;
    case 'Date':
      return <DatePicker
        style={{ width: '100%' }}
        format="DD-MM-YYYY"
        disabled={readonly}
      />;
    case 'Dropdown':
      if (!fieldData?.options) return null;
      return (
        <Select
          placeholder="Select"
          showArrow
          showSearch
          options={fieldData?.options}
          disabled={readonly}
        />
      );
    case 'Checkbox':
      return (
        <Checkbox
          disabled={readonly}
        >
          {fieldData?.label}
        </Checkbox>
      );
    default:
      return <Input placeholder={`Enter ${fieldData?.label || fieldData?.field_name}`} disabled={readonly} />;
  }
};

const ClaimDetailsForm: React.FC<Props> = ({ onNext, onPrev, form, readonly, dynamicFields }) => {
  const validateNext = useCallback(()=>{
    form.validateFields()
    .then((val) => {
      onNext?.()
    })
    .catch((err) => {
      errorNotification('Please check all fields before going ahead')
    });
  },[form, onNext]);
  const formComponent = <>
    <div className="card-title mb-32">Claim Details</div>
    <Space direction="vertical" style={{width: '50%'}}>
      {dynamicFields?.length > 0 && dynamicFields?.map((data: DynamicClaimsApiFields, index: number) => (
        <Form.Item
          key={index}
          label={data?.additional_details?.description ?? data?.label ?? data?.field_name}
          wrapperCol={{ span: 24 }}
          labelCol={{ span: 24 }}
          name={['insurer_payload', data?.field_name]}
          validateTrigger="onBlur"
          rules={
            data?.is_mandatory
              ? [{ required: true, message: `${data?.label || data?.field_name} is required` }]
              : []
          }
          {...(data?.field_type === 'Checkbox' ? { valuePropName: 'checked' } : {})}
        >
          {renderDynamicFormField(data, readonly)}
        </Form.Item>
      ))}
      {/* <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="What kind of claim are you raising? (e.g., hospitalization, day care, maternity, accident)"
        name="claim_type"
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="Please specify the type of treatment or service you’re claiming for."
        name="sub_claim_type"
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="How much are you claiming for this treatment?"
        name="claim_amount"
      >
        <Input disabled={readonly} />
      </Form.Item>
      <div className="label" style={{ color: "#5F6467", marginBottom: '4px' }}>Please enter the Hospital's address</div>
      <Space direction="vertical" style={{ gap: '0', width: '100%' }}>
        <Form.Item
          wrapperCol={{ span: 8 }}
          name={['hospital_address', 'name']}
        >
          <Input disabled={readonly} placeholder="Hospital Name" />
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 24 }}
          name={['hospital_address', 'address']}
        >
          <Input disabled={readonly} placeholder="Address" />
        </Form.Item>
        <Space direction="horizontal" style={{ width: '100%' }}>
          <Form.Item
            wrapperCol={{ span: 24 }}
            name={['hospital_address', 'state']}
          >
            <Input disabled={readonly} placeholder="State" />
          </Form.Item>
          <Form.Item
            wrapperCol={{ span: 24 }}
            name={['hospital_address', 'city']}
          >
            <Input disabled={readonly} placeholder="City" />
          </Form.Item>
          <Form.Item
            wrapperCol={{ span: 24 }}
            name={['hospital_address', 'pincode']}
          >
            <Input disabled={readonly} placeholder="Pincode" />
          </Form.Item>
        </Space>
      </Space>

      <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="What’s your phone number?"
        name={['filled_by', 'phone']}
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="What type of loss is this? (e.g., accidental, illness-related)"
        name={'loss_classification'}
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="Please select the relevant category for the claim."
        name={'loss_category'}
      >
        <Input disabled={readonly} />
      </Form.Item>
      <Form.Item
        wrapperCol={{ span: 24 }}
        labelCol={{ span: 24 }}
        label="Is there anything you’d like to share with the insurer?"
        name={'external_remarks'}
      >
        <Input.TextArea disabled={readonly} />
      </Form.Item> */}
    </Space></>

  if (readonly) {
    return <>{formComponent}</>
  }

  return <FormWrapper primaryButton={{
    active: true,
    loading: false,
    disabled: false,
    title: 'Next',
    onClick: onNext ? validateNext : () => { }
  }} secondaryButton={{
    active: true,
    loading: false,
    disabled: false,
    title: 'Back',
    onClick: onPrev ? onPrev : () => { }
  }}>
    {formComponent}
  </FormWrapper>
};

export default ClaimDetailsForm;
